import { render, staticRenderFns } from "./SSelectArticles.vue?vue&type=template&id=463dff61"
import script from "./SSelectArticles.vue?vue&type=script&lang=js"
export * from "./SSelectArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports